<template>
   <vue-final-modal
      v-model="showMail" 
      classes="modal-container"
      content-class="show-mail-modal-content"
      @before-open="beforeOpen()"
      @click-outside="beforeClose()"
      :click-to-close="false"
      drag-selector=".drug-area"
      :drag="true"
      >
      <button 
         id="prime"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="beforeClose()"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__mail tx-cl-white row row-cols-auto drug-area">
         <card-rectangle :rectangleCard="myCardRectangle" class="col mt-1"/>
         <div class="col pe-1 pt-1 fs-17"><b>{{currentTitle}}</b></div>
         <div class="col"></div>
      </span>
      <!--
      {{dataFromCard}}
      -->
      <div class="show-mail mt-1">
         <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('final').focus()"></div>
         <div v-if="noSendingError">
            <div v-if="mailData" class="container bg-light rounded py-2" id="element-to-print">
               <div v-if="mailData.date">
                  <div class="bg-light rounded my-3 ttl mt-0 p-0 fs-14 shadow-sm"> <b>{{ mailData.subject }}</b> </div>
                  <div class="bg-light rounded my-1 ttl mt-0 p-0 fs-13"> <b><i>Desde:</i></b> {{ mailData.from }} </div>
                  <div class="bg-light rounded my-1 ttl mt-0 p-0 fs-13"> <b><i>Fecha:</i></b> {{ mailSendDate }} </div>
                  <div class="bg-light rounded my-1 ttl mt-0 p-0 fs-13"> <b><i>Para:</i></b> {{ mailData.to }} </div>
                  <div v-if="mailData.cc">
                     <div class="bg-light rounded my-1 ttl mt-0 p-0 fs-13"> <b><i>CC:</i></b> {{ mailData.cc }} </div>
                  </div>
                  <div v-if="mailData.bcc">
                     <div class="bg-light rounded my-1 ttl mt-0 p-0 fs-13"> <b><i>CCO:</i></b> {{ mailData.bcc }} </div>
                  </div>
                  <div v-if="mailData.attachs && mailData.attachs.length > 0" class="mt-2">
                     <b><i class="fs-14 ttl"> Archivos adjuntos ({{ mailData.attachs.length }})</i></b>
                     <div class="bg-light rounded my-1 ttl mx-0 mt-0 p-1 fs-13 row row-cols-auto">
                        <div v-for="(attach, index) in mailData.attachs" :key="index" class="px-2 text-center shadow">
                           {{ attach.name }}
                           <div v-if="attach.size"> ({{attach.size}})</div>
                        </div>
                     </div>
                  </div>
                  <div v-html="mailData.body" class="bg-light rounded my-1 ttl mt-3 p-1 fs-13 shadow"></div>
               </div>
               <div v-else class="container bg-danger rounded py-2 ">
                  <p class="mb-1 shadow"><b> No se ha enviado el mail debido a que no se encontraron los siguentes archivos que deben adjuntarse al mismo: </b></p>
                  <div v-for="(attach, index) in mailData.attachs" :key="index" class="px-1 shadow">
                     <i v-if="attach.id != null && attach.id == 0 ">{{ attach.name }}</i>
                  </div>
               </div>
               <!--
               <div class="tx-cl-black" >{{readJson}}</div>
               <br>
               <div class="tx-cl-black" >{{mailData}}</div>
               -->
            </div>
            <div v-else class="container bg-danger rounded py-2 ">
               <p v-if="errorGetMailData" ><b> Puede haber un error en la configuración de los parámetros de envío del mail para este tipo de tarjeta, o bien es un error de red. </b></p>
               <p v-else><b> No se encontró un modelo de mail para este tipo de tarjeta, controlar si las ETIQUETAS están bien asignadas en los correspondientes tableros.</b><br><i>Si las etiquetas están bien, controlar los parámetros de envío del mail para este tipo de tarjeta.</i></p>
            </div>
         </div>
         <div v-else class="container bg-danger rounded py-2">
            <p class="mb-1 shadow"><b> No se ha enviado el mail, la causa más probable es que algunas de las siguietes direcciones de email no existen o tienen un formato inválido: </b></p>
            <div class="px-1 shadow">
               <i>{{ mailData.to }}</i>
            </div>
            <div v-if="mailData.cc" class="px-1 shadow">
               <i>{{ mailData.cc }}</i>
            </div>
            <div v-if="mailData.bcc" class="px-1 shadow">
               <i>{{ mailData.bcc }}</i>
            </div>
         </div>
      </div>
      <!--
            <p v-if="errorGetMailData" ><b> Puede haber un error en la configuración de los parámetros de envío del mail para este tipo de tarjeta, o bien es un error de red. </b></p>
            <p v-else><b> No se encontró un modelo de mail, controlar los parámetros de envío del mail para este tipo de tarjeta. </b></p>
      -->
      <div class="row p-0 justify-content-between mx-0">
         <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
         <div class="d-flex justify-content-end pt-1 px-0 col-10">
            <button v-show="showSendButton" type="button" 
                  :tabindex="tabIndexNumber(3)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="sendMail()"
                  :disabled=" !mailData "
                  >
               Enviar Mail
            </button>
            <button v-show="showDownButton" type="button" 
                  :tabindex="tabIndexNumber(3)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="generatePDF()"
                  >
               Descargar
            </button>
            <button type="button" 
                  id="final"
                  :tabindex="tabIndexNumber(4)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="beforeClose()"
                  >
               Salir
            </button>
            <div :tabindex="tabIndexNumber(5)" onfocus="document.getElementById('prime').focus()"></div>
         </div>
      </div>
   </vue-final-modal>
   <do-not-close  v-if="doNotClose"
      :messages="messages"
      />
</template>

<script>

import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment';
import html2pdf from 'html2pdf.js';

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';
import CardRectangle from '../CardRectangle.vue';
import DoNotClose from './DoNotClose.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      CardRectangle,
      DoNotClose
   },

   props: {
      dataFromCard: String
   },

   setup( props ) {

      const initialTabIndex = ref(150)
      const showMail = ref(true)
      const myCircle = ref({})
      const myCardRectangle = ref({})
      const store = useStore()
      const router = useRouter()
      const oDataFromCard = ref({})
      const mailData = ref({})
      //const mailData = ref(null)
      const errorGetMailData = ref(false)
      const mailSendDate = ref(null)
      const doNotClose = ref(false)
      const messages = ref([])
      const showSendButton = ref(true)
      const currentTitle = ref('')
      const noSendingError = ref(true)

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const boardId = WspService.getBoardId(store)

      const readJson = ref({})
      const showDownButton = ref(false)

      function beforeClose() {
         nextTick(() => { router.go(-1) })
      }

      async function beforeOpen() {
         /*
         const filePath = process.env.VUE_APP_BASE_CNTT_ATT_FOLDER + 'jsonMail.jm';
         console.log(filePath)
           // readJson.value = JSON.parse(data);
         
         //fetch('https://scraping-demo-api-json-server.vercel.app/products')
         fetch(filePath)
            .then(response => {
               if (!response.ok) {
                     throw new Error('Network response was not ok ' + response.statusText);
               }
               return response.json();
            })
            .then(data => {
               console.log(JSON.parse(data))
               readJson.value = data
            })
            .catch(error => {
               console.error('There has been a problem with your fetch operation:', error);
            });
         */
         oDataFromCard.value = JSON.parse( props.dataFromCard )

         let bodyText = ''
         if ( oDataFromCard.value.mailType == 'VSM' ) {
            currentTitle.value = 'Consulta de Mails Enviados'
            showSendButton.value = false
            showDownButton.value = true
         }
         if ( oDataFromCard.value.mailType == 'RCP' ) {
            currentTitle.value = 'Mail de Recepción de la Solicitud del Afiliado'
         }
         if ( oDataFromCard.value.mailType == 'CMM' ) {
            currentTitle.value = 'Mail de Comunicación al Afiliado'
         }
         if ( oDataFromCard.value.mailType == 'NTF' ) {
            currentTitle.value = 'Mail de Notificación al Afiliado'
         }
         if ( oDataFromCard.value.mailType == 'INF' ) {
            currentTitle.value = 'Mail de Información al Afiliado'
         }

         if ( store.state.wspace.updateDraftNotification !== undefined ) {
            bodyText = store.state.wspace.updateDraftNotification
         }

         WspService.getMyCircle( currentUserId.value )
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => { console.log(error) })

         await WspService.getMailData( 
            oDataFromCard.value.mailType,
            oDataFromCard.value.contentId,
            currentUserId.value,
            bodyText,
            boardId,
            oDataFromCard.value.attachId
            )
         .then(response => {
            mailData.value = response.data
            //mailData.value = JSON.parse( readJson.value )
            mailSendDate.value = moment(mailData.value.date).format('DD/MM/YYYY HH:mm')
         })
         .catch(error => { 
            mailData.value = null
            errorGetMailData.value = true
            console.log(error) 
         })

         WspService.getMyCardRectangle( oDataFromCard.value.cardTypeId )
         .then(response => {
            myCardRectangle.value = response.data
         })
         .catch(error => { console.log(error) })

      }
      
      async function sendMail() {
         messages.value = [
            'No cierre esta pantalla, espere a que vuelva a aparecer la pantalla anterior.',
            'Esto permitirá enviar el email y adjuntar una copia en esta tarjeta.'
            ]
         showSendButton.value = false
         doNotClose.value = true
         
         await WspService.sendFormMail( 
            oDataFromCard.value.mailType, 
            oDataFromCard.value.contentId,
            currentUserId.value,
            store.state.wspace.updateDraftNotification,
            boardId,
            oDataFromCard.value.cellId    // cellId,
            )
         .then( response => {
            mailData.value = response.data
            mailSendDate.value = moment(mailData.value.date).format('DD/MM/YYYY HH:mm')
            nextTick(() => { generateJDM() })
         })
         .catch(error => { 
            console.log(error)
            doNotClose.value = false
            noSendingError.value = false
         })
      }
      
      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }
      
      async function generateJDM() {
         //
         /*
         let fileName = 'Mail.pdf'
         if ( oDataFromCard.value.mailType == "RCP" ) {
            fileName = 'MRCP-' + zeroPad( oDataFromCard.value.contentId, 8 ) + '-' + mailData.value.cuil + '.pdf'
         }
         */
         let mailTypeName = 'Recepción'
         let negativeId = -14
         if ( oDataFromCard.value.mailType == 'NTF' ) {
            mailTypeName = 'Notificación'
            negativeId = -17
         }
         if ( oDataFromCard.value.mailType == 'CMM' ) {
            mailTypeName = 'Comunicación'
            negativeId = -18
         }
         if ( oDataFromCard.value.mailType == 'INF' ) {
            mailTypeName = 'Información'
            negativeId = -17
         }
         //let fileName = 'Mail-' + mailTypeName + '-' + zeroPad( oDataFromCard.value.contentId, 8 ) + '-' + mailData.value.cuil + '.pdf'
         let strCuil = ''
         if ( mailData.value.cuil != null ) {
            strCuil = '-' + mailData.value.cuil
         }
         //let fileName = 'Mail-' + mailTypeName + '-' + zeroPad( oDataFromCard.value.contentId, 8 ) + '-' + mailData.value.cuil + '.jdm'
         let fileName = 'Mail-' + mailTypeName + '-' + zeroPad( oDataFromCard.value.contentId, 8 ) + strCuil + '.jdm'
         console.log(oDataFromCard.value.mailType)
         console.log(fileName)
         /*
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         let file = new File([blob], 
            fileName,
            { type: 'application/pdf' })
         */
         const blob = new Blob([JSON.stringify(mailData.value)], { type: 'text/plain' })
         let file = new File([blob], fileName, { type: 'text/plain' })
         //
         // Create a download link for the resulting PDF Blob and trigger the download
            WspService.addAttachContent(
               oDataFromCard.value.contentId,     // contentId, 
               oDataFromCard.value.cellId,    // cellId,
               oDataFromCard.value.boardId,
               currentUserId.value,     // userId, 
               file   // attachFile
            )
            .then(response => {            
               console.log(response.data)
               console.log("attach ok: ")
               //store.dispatch("wspace/setContentId", -14)
               store.dispatch("wspace/setContentId", negativeId)
               doNotClose.value = false
            })
            .catch(error => {
               console.log(error);
            });
         
         //         
      }

      async function generatePDF() {
         //
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         let file = new File([blob], mailData.value.subject + '.pdf', { type: 'application/pdf' })
         // Create a download link for the resulting PDF Blob and trigger the download
         const downloadLink = document.createElement('a');
         downloadLink.href = URL.createObjectURL(file);
         downloadLink.download = file.name;
         downloadLink.onclick = () => downloadLink.remove();
         document.body.appendChild(downloadLink);
         downloadLink.click();
         //         
      }
      
      function createPDF() {
         return new Promise( (resolve, reject) => {
            console.log('create PDF function executed!');
            let element = document.getElementById('element-to-print');

            let opt = {
               margin: 10,
               enableLinks: false,
               image: {type: 'jpeg', quality: 0.95},
               html2canvas: {scale: 2, useCORS: true}
               //jsPDF: {format: 'a4', orientation: 'portrait'}
            };

            try {
                const blob = html2pdf().set(opt).from(element).outputPdf('blob');
                resolve(blob);
            } catch (e) {
                reject(e);
            }
         });
      }
      
      return {
         beforeClose, beforeOpen,
         currentTitle,
         doNotClose,
         errorGetMailData,
         generatePDF,
         mailData, mailSendDate, messages,
         myCardRectangle, myCircle,
         noSendingError,
         oDataFromCard,
         readJson,
         sendMail, showMail, showSendButton, showDownButton,
         tabIndexNumber
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.show-mail-modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 300px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__mail {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.show-mail {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
.tx-cl-black {
   color: black;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
.ttl {
   color: black;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-16 {
   font-size: 16px;
}
.fs-17 {
   font-size: 17px;
}
.fs-18 {
   font-size: 18px;
}
</style>
